export const assetType = ['CURRENT', 'FIXED']
